import React, { useState, useRef, useLayoutEffect } from 'react'
import styled from 'styled-components'
import Card from './Card'
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 45px;
    margin-top: 90px;
    .content {
        display: grid;
        grid-template-columns: 30px 1fr 30px;
        align-items: center;
        .cards {
            white-space: nowrap;
            overflow: hidden;
            .slider {
                transition: 0.8s ease-in-out;
            }
        }
    }
    .icon {
        font-size: 30px;
    }
`

function Feedback() {

    const slider = useRef<HTMLDivElement>(null)
    const [translate, setTranslate] = useState(0)

    const ClickLeft = () => {
        if(slider.current) {
            const width = slider.current.clientWidth
            if (width <= 580) {
                setTranslate(translate + width)
            } else {
                setTranslate(translate + width/2)
            }
        }
    }

    const ClickRight = () => {
        if(slider.current) {
            const width = slider.current.clientWidth
            if (width <= 580) {
                setTranslate(translate - width)
            } else {
                setTranslate(translate - width/2)
            }
        }
    }

    useLayoutEffect(() => {
        if(slider.current) {
            slider.current.style.transform = `translateX(${translate}px)`
        }
    }, [translate, slider])

    return (
        <Wrapper>
            <h2>Feedback</h2>
            <div className='content'>
                <FaAngleLeft onClick={ClickLeft} className='icon' />
                <div className='cards'>
                    <div
                    ref={slider}
                    className='slider'>
                        <Card />
                        <Card />
                        <Card />
                        <Card />
                    </div>
                </div>
                <FaAngleRight onClick={ClickRight} className='icon' />
            </div>
        </Wrapper>
    );
}

export default Feedback;